/**
 * Core: Mint Setup.
 * -----------------------------------------------------------------------------
 * - Setup functions for the core Mint app.
 */
import { createPinia } from 'pinia'

import Helpers from '~/core/mint/plugins/helpers'

/**
 * Set the usable directives for the app.
 * - Auto-register all directives with a 'global' keyword in their filename
 * @param {Object} app - Vue app object.
 */
export function setDirectives(app) {

  /**
   * Directives
   * - Auto-register all directives with 'mint-' keyword in the filename.
   */
  const directives = require.context(
    '~/core/mint/directives/',
    true,
    /\.js$/,
  )

  directives.keys().forEach(key => {
    const directive = directives(key).default
    app.directive(directive.name, directive.directive)
  })
}

/**
 * Set the usable mixins for the app.
 * @param {Object} app - Vue app object.
 */
export function setMixins(app) {

  /**
    * Mixins
    * - Auto-register all mixins with 'mint-' keyword in the filename.
    */
  const mixins = require.context(
    '~/core/mint/mixins',
    true,
    /\.js$/,
  )

  mixins.keys().forEach(key => {
    app.mixin(mixins(key).default)
  })
}

/**
 * Set the usable plugins for the app.
 * @param {Object} app - Vue app object.
 */
export function setPlugins(app) {
  app.use(createPinia())
  app.use(Helpers)
}
